/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tracking_Playback_Invalid_DateInputs */

const vi_tracking_playback_invalid_date = /** @type {(inputs: Tracking_Playback_Invalid_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Định dạng ngày không hợp lệ`)
};

/**

* @param {Tracking_Playback_Invalid_DateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tracking_playback_invalid_date = /** @type {((inputs?: Tracking_Playback_Invalid_DateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tracking_Playback_Invalid_DateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tracking_playback_invalid_date(inputs)
});